/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import RectangleLoader from "../../../../shared/components/loaders/RectangleLoader";
import { useStyles } from "../../styles";

interface CardTitleProps {
  title: string;
  titleInlineAction?: React.ReactNode;
  isLoading?: boolean;
  testId?: string;
  titleExtention?: string | React.ReactNode;
  wrappedTitleInlineAction?: string | React.ReactNode;
}

const CardTitle = ({
  title,
  titleInlineAction,
  isLoading,
  testId,
  titleExtention,
  wrappedTitleInlineAction
}: CardTitleProps) => {
  const { cardTitle, cardTitleExtention, wrappedCardTitleInlineAction } =
    useStyles({});

  return (
    <div css={css([cardTitle])}>
      {isLoading ? (
        <RectangleLoader width={136} height={20} testId={testId} />
      ) : (
        <>
          <div>
            <div css={css(cardTitleExtention)}>
              <Typography variant="body1Medium">{title}</Typography>
              {/* empty space: */}
              <Typography variant="body2Medium">&nbsp;</Typography>
              {titleExtention}
            </div>
            {wrappedTitleInlineAction && (
              <div css={css(wrappedCardTitleInlineAction)}>
                {wrappedTitleInlineAction}
              </div>
            )}
          </div>
          {titleInlineAction && <div>{titleInlineAction}</div>}
        </>
      )}
    </div>
  );
};

export default CardTitle;
